
import axios from 'axios'

/**
 * Service to call bill endpoints
 */
const BillService = {
  /**
   * Get a single bill by ID
   * @param billNo
   * @returns {*}
   */
  get (billNo) {
    return new Promise((resolve, reject) => {
      axios
        .get(`bills/${billNo}`)
        .then(result => {
          resolve(result)
        })
        .catch(error => {
          if (error.response) {
            reject(error.response.data)
          } else {
            reject(new Error(error))
          }
        })
    })
  },

  initiateFunding (params) {
    return new Promise((resolve, reject) => {
      axios
        .post('fmceb/bills/initiate-fund-wallet', params)
        .then(result => {
          resolve(result)
        })
        .catch(error => {
          if (error.response) {
            reject(error.response)
          } else {
            reject(new Error(error))
          }
        })
    })
  }

}

export default BillService



// WEBPACK FOOTER //
// ./src/services/bill.service.js